import { Container, Box, Grid, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useCallback, useState } from 'react';
import { withErrorBoundary } from '../../layouts/RoutedErrorBoundary';
import { ResetPasswordSuccessDialog, ResetPasswordHeader, ResetPasswordTitle, ResetPasswordForm } from './components';

export type ResetPasswordPageProps = {
    token: string;
};

const ResetPasswordPage = ({ token }: ResetPasswordPageProps) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.up('sm'));
    const [completed, setCompleted] = useState(false);

    const next = useCallback(() => setCompleted(true), [setCompleted]);

    return (
        <>
            <ResetPasswordSuccessDialog show={completed} />
            <Container maxWidth="xs">
                <Box pt={isSmall ? 12 : 5}>
                    <Grid spacing={2} container>
                        <ResetPasswordHeader />
                        <ResetPasswordTitle />
                        <ResetPasswordForm next={next} token={token} />
                    </Grid>
                </Box>
            </Container>
        </>
    );
};

export default withErrorBoundary(ResetPasswordPage);
